import React from 'react';
import { decode } from 'html-entities';
import './ProductDestinationNote.scss';
import translateService from '../../../common/translateService';
import { openDestinationNotes } from '../../../services/product/productInteraction';

const ProductDestinationNote = (props) => {
    const toggleSection = (e) => {
        openDestinationNotes(e);
    };

    return (
        <>
            {Boolean(props.destinationNote) && (
                <>
                    <p
                        className='prd-destination-note-expander prd-link'
                        onClick={(e) => {
                            toggleSection(e);
                        }}>
                        {translateService.get('common.whyDoISeeThisPrice')}
                    </p>
                    <div
                        className='prd-destination-note'
                        dangerouslySetInnerHTML={{
                            __html: decode(props.destinationNote),
                        }}
                    />
                </>
            )}
        </>
    );
};

export default ProductDestinationNote;
